import {find} from 'lodash';
import PipelineStepModel from '../pipeline_step_model';

export default class ColumnActionModel extends PipelineStepModel {
    columnId = '';

    constructor({column = {}, columnId, ...data}) {
        super(data);
        this.columnId = columnId || column.id;
        this.column = column;
    }

    getColumn(table) {
        return find(table.columns, {id: this.columnId});
    }

    setColumn(column) {
        this.columnId = column.id;
    }
}
